import { ExpandableSection, Flex, smBumps, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../domain'
import { useExpandableSectionConfig } from '../../../hooks/adjustments/expandableSection'
import { toQuoteData } from '../../../hooks/adjustments/proposal/disclosure/data'
import {
  tDefaults,
  TKeyBuilder,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { QuoteManagementConfig } from '../../../state/configuration'
import { getFormatter } from '../../formBuilder'

export const QuoteInformation: FunctionComponent<{
  config: QuoteManagementConfig
  quote: Quote
  tKey: TKeyBuilder
}> = ({ config, quote, tKey }) => {
  const { t } = useWriskTranslation()

  const toData = toQuoteData(quote)

  const [header, inputsToRender] = useExpandableSectionConfig({
    sectionId: config.id,
    inputs: config.inputs,
    tKey,
    toData,
  })

  const expandedComponents = inputsToRender.map((input) => {
    const Formatter = getFormatter(input.type)

    return (
      <Flex
        key={input.name}
        px={smBumps}
        py={2}
        flexDirection='column'
        alignItems='flex-start'
      >
        <Typo typoSize='xs' color='bodySecondary' mb={1}>
          {t(tDefaults('product.headers', input.name))}
        </Typo>
        <Typo as='pre'>
          <Formatter input={input} value={toData(input.adjustment)} t={t} />
        </Typo>
      </Flex>
    )
  })

  return (
    <ExpandableSection reversed header={<Typo fontWeight='bold'>{header}</Typo>}>
      {expandedComponents}
    </ExpandableSection>
  )
}
